// components/DocumentUpload.tsx

import React, { useState } from "react";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { Group, Text, Image, Stack, rem, Center, Flex } from "@mantine/core";
import {
  IconFileText,
  IconFileSpreadsheet,
  IconUpload,
  IconX,
} from "@tabler/icons-react";

interface Props {
  onFileSelect: (file: File | null) => void;
}

const getFileTypeIcon = (file: File) => {
  const type = file.type;

  if (type === "application/pdf") {
    return <IconFileText size={48} />;
  }

  if (
    type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    type === "application/vnd.ms-excel"
  ) {
    return <IconFileSpreadsheet size={48} />;
  }

  if (type.startsWith("image/")) {
    return (
      <Image
        src={URL.createObjectURL(file)}
        alt="preview"
        h={80}
        w="auto"
        fit="contain"
        radius="md"
      />
    );
  }

  return <IconFileText size={48} />;
};

const DocumentUpload: React.FC<Props> = ({ onFileSelect }) => {
  const [file, setFile] = useState<File | null>(null);

  const handleDrop = (acceptedFiles: File[]) => {
    const selected = acceptedFiles[0];
    if (selected) {
      setFile(selected);
      onFileSelect(selected);
    }
  };

  return (
    <Stack>
      <Dropzone
        onDrop={handleDrop}
        onReject={() => {
          setFile(null);
          onFileSelect(null);
        }}
        maxSize={10 * 1024 ** 2} // 10MB
        accept={[
          MIME_TYPES.pdf,
          MIME_TYPES.xlsx,
          MIME_TYPES.xls,
          MIME_TYPES.png,
          MIME_TYPES.jpeg,
        ]}
      >
        <Group
          justify="center"
          mih={100}
          style={{ pointerEvents: "none" }}
        >
          <Dropzone.Accept>
            <IconUpload
              style={{ width: rem(40), height: rem(40), color: "green" }}
              stroke={1.5}
            />
          </Dropzone.Accept>
          <Dropzone.Reject>
            <IconX
              style={{ width: rem(40), height: rem(40), color: "red" }}
              stroke={1.5}
            />
          </Dropzone.Reject>
          <Dropzone.Idle>
            <IconUpload
              style={{ width: rem(40), height: rem(40) }}
              stroke={1.5}
            />
          </Dropzone.Idle>
          <Flex direction={'column'} align={'center'}>
            <Text size="md" inline>
              Dosya Yükleyin.
            </Text>
            <Text size="xs" c="dimmed" inline mt={7}>
              Yalnızca PDF, Excel veya 10MB altındaki görseller desteklenir
            </Text>
          </Flex>
        </Group>
      </Dropzone>

      {file && (
        <Center mt="md">
          <Stack align="center" gap="xs">
            {getFileTypeIcon(file)}
            <Text size="sm">{file.name}</Text>
          </Stack>
        </Center>
      )}
    </Stack>
  );
};

export default DocumentUpload;
